import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/* =========================
    CSV DOWNLOAD
========================= */

export const downloadCSV = ({ data = [], fileName = "data" }) => {
  const worksheet = XLSX.utils.json_to_sheet(data);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const csvOutput = XLSX.write(workbook, {
    bookType: "csv",
    type: "array",
  });

  const blob = new Blob([csvOutput], {
    type: "text/csv;charset=utf-8;",
  });

  saveAs(blob, `${fileName}.csv`);
};

/* =========================
    EXCEL DOWNLOAD
========================= */

export const downloadExcel = ({
  data = [],
  fileName = "data",
  sheetName = "Sheet1",
}) => {
  const worksheet = XLSX.utils.json_to_sheet(data);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(blob, `${fileName}.xlsx`);
};

/* =========================
    PDF DOWNLOAD
========================= */

export const downloadPDF = ({
  data = [],
  fileName = "data",
  title = "Data",
  columns = [],
}) => {
  const doc = new jsPDF();

  doc.setFontSize(16);

  doc.text(title, 14, 15);

  autoTable(doc, {
    startY: 25,

    head: [columns.map((column) => column.label)],

    body: data.map((row) =>
      columns.map((column) => {
        return row[column.id] || "-";
      }),
    ),
  });

  doc.save(`${fileName}.pdf`);
};
